"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_MENU_INVITE_ICON = exports.HELP_MENU_BEGINNER_GUIDE = exports.HELP_MENU_SHORTCUT_PANEL = exports.ICON_NOTIFICATION = exports.ICON_SPACE_MANAGE = exports.ICON_TEMPLATE = exports.ICON_ADDRESS = exports.ICON_WORKBENCH = void 0;
/* eslint_disable */
// The id of the Wig table part (excluding the working directory)
const NAV_PREFIX = 'NAV_';
const PREFIX = 'NAV__';
exports.ICON_WORKBENCH = NAV_PREFIX + 'ICON_WORKBENCH'; // navigation bar icon_workbench
exports.ICON_ADDRESS = NAV_PREFIX + 'ICON_ADDRESS'; // navigation bar icon_address book
exports.ICON_TEMPLATE = NAV_PREFIX + 'ICON_TEMPLATE'; // navigation bar icon_template center
exports.ICON_SPACE_MANAGE = NAV_PREFIX + 'ICON_SPACE_MANAGE'; // navigation bar icon_space management
exports.ICON_NOTIFICATION = NAV_PREFIX + 'ICON_NOTIFICATION'; // navigation bar icon_notification center icon
// context of help_menu
exports.HELP_MENU_SHORTCUT_PANEL = PREFIX + 'SHORTCUT_PANEL';
exports.HELP_MENU_BEGINNER_GUIDE = PREFIX + 'BEGINNER_GUIDE';
// context of user_menu
exports.USER_MENU_INVITE_ICON = NAV_PREFIX + 'USER_MENU_INVITE_ICON';
//# sourceMappingURL=nav_id.js.map